import { franc } from "franc-min";

const ISO_TO_LANGUAGE = { hin: "hi", mar: "mr", npi: "ne", nep: "ne", ben: "bn", asm: "as", urd: "ur", snd: "sd" };
const SCRIPTS = [
  { pattern: /[\u0c00-\u0c7f]/g, fallback: "te" },
  { pattern: /[\u0b80-\u0bff]/g, fallback: "ta" },
  { pattern: /[\u0c80-\u0cff]/g, fallback: "kn" },
  { pattern: /[\u0d00-\u0d7f]/g, fallback: "ml" },
  { pattern: /[\u0a80-\u0aff]/g, fallback: "gu" },
  { pattern: /[\u0a00-\u0a7f]/g, fallback: "pa" },
  { pattern: /[\u0b00-\u0b7f]/g, fallback: "or" },
  { pattern: /[\u0900-\u097f]/g, fallback: "hi", candidates: ["hin", "mar", "npi", "nep"] },
  { pattern: /[\u0980-\u09ff]/g, fallback: "bn", candidates: ["ben", "asm"] },
  { pattern: /[\u0600-\u06ff]/g, fallback: "ur", candidates: ["urd", "snd"] },
];

// Script narrows the candidates; franc distinguishes shared scripts on longer replies.
// Short/shared-script phrases remain best-effort, not a claim of perfect language ID.
export const replyLanguage = (text = "") => {
  const clean = text.replace(/\[\[[^\]]+\]\]/g, "").replace(/https?:\/\/\S+/g, "");
  const candidates = SCRIPTS.map((script) => ({ ...script, count: (clean.match(script.pattern) || []).length })).sort((a, b) => b.count - a.count);
  const script = candidates[0];
  if (!script || script.count < 2) return "en";
  // Do not switch an otherwise English reply just because it quotes an Indian word.
  if ((clean.match(/[a-z]/gi) || []).length > script.count * 2.5) return "en";
  if (script.candidates && script.count >= 20) {
    const detected = ISO_TO_LANGUAGE[franc(clean, { only: script.candidates, minLength: 20 })];
    if (detected) return detected;
  }
  if (script.fallback === "bn" && /[\u09f0\u09f1]/.test(clean)) return "as";
  return script.fallback;
};

export const replyDirection = (text) => ["ur", "sd"].includes(replyLanguage(text)) ? "rtl" : "auto";